"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var _HR = _interopRequireDefault(require("UIComponents/elements/HR"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _ProductCatalogModal = _interopRequireDefault(require("ui-addon-upgrades/_core/productCatalog/ProductCatalogModal"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _MerchandiseSelectors = require("../../selectors/MerchandiseSelectors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      font-weight: 600;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledLink = (0, _styledComponents.default)(_UILink.default).withConfig({
  displayName: "ViewAllFeatures__StyledLink",
  componentId: "vo04tp-0"
})(["&.features-link{", "}"], _responsiveBreakpoints.default.phone(_templateObject()));

var ViewAllFeaturesContainer = _styledComponents.default.div.withConfig({
  displayName: "ViewAllFeatures__ViewAllFeaturesContainer",
  componentId: "vo04tp-1"
})(["position:absolute;bottom:12px;left:0;width:100%;text-align:center;hr{background-color:", ";margin-bottom:16px !important;}"], _colors.BATTLESHIP);

var ViewAllFeatures = function ViewAllFeatures(_ref) {
  var edition = _ref.edition,
      hub = _ref.hub,
      use = _ref.use,
      gaClassName = _ref.gaClassName;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var merchandiseMap = (0, _reactRedux.useSelector)(_MerchandiseSelectors.merchandiseSelector);

  var toggleViewAllFeaturesModal = function toggleViewAllFeaturesModal() {
    setIsModalOpen(!isModalOpen);

    if (!isModalOpen) {
      (0, _getUsageTracker.default)().track('clickToViewModal', {
        name: 'compare-feature-modal',
        hub: hub,
        edition: edition,
        inCalculator: false
      });
    }
  };

  var ViewAllFeaturesContent = _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(StyledLink, {
    className: "m-left-0 features-link " + gaClassName,
    onClick: toggleViewAllFeaturesModal
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.highlightedMerchCards.seeAllFeatures",
    className: gaClassName
  })), isModalOpen && _react.default.createElement(_ProductCatalogModal.default, {
    hub: hub,
    onCloseClick: toggleViewAllFeaturesModal,
    merchandiseMap: merchandiseMap
  }));

  if (use === 'inline') {
    return ViewAllFeaturesContent;
  }

  return _react.default.createElement(ViewAllFeaturesContainer, null, _react.default.createElement(_HR.default, {
    className: "m-bottom-5"
  }), ViewAllFeaturesContent);
};

ViewAllFeatures.propTypes = {
  hub: _propTypes.default.string.isRequired,
  edition: _propTypes.default.string,
  gaClassName: _propTypes.default.string.isRequired,
  use: _propTypes.default.string
};
var _default = ViewAllFeatures;
exports.default = _default;
module.exports = exports.default;